require('./date-formater');

module.exports = 'date-formater';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/dateFormater/index.js
 ** module id = 104
 ** module chunks = 1
 **/